<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: {
    type: Object as () => NuxtError,
    required: true
  }
})

const { t } = useI18n()

// Nitro and Nuxt fill an empty statusMessage with untranslated defaults, so
// those are discarded in favour of a localized text picked by status code
const FRAMEWORK_DEFAULT_MESSAGES = ['Not Found', 'Server Error', 'Request Error', 'Page not found']

const message = computed(() => {
  const statusMessage = props.error.statusMessage?.trim()
  const isFrameworkDefault =
    !statusMessage || FRAMEWORK_DEFAULT_MESSAGES.some((text) => statusMessage.startsWith(text))

  if (!isFrameworkDefault) return statusMessage

  return props.error.statusCode === 404
    ? t('error.404_message')
    : t('common.server_error_try_later')
})
</script>

<template>
  <div class="flex h-full flex-col items-center justify-center gap-5 p-6">
    <h1>{{ t('error.title') }}: {{ props.error.statusCode }}</h1>
    <p class="text-center text-sm" v-html="message" />
    <Button variant="blue" as-child>
      <NuxtLinkLocale to="/">{{ t('error.go_home') }}</NuxtLinkLocale>
    </Button>
  </div>
</template>
